import { Component, OnInit, Input } from '@angular/core';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-profile-patient-info',
  templateUrl: './profile-patient-info.component.html',
  styleUrls: ['./profile-patient-info.component.scss']
})
export class ProfilePatientInfoComponent implements OnInit {
  isEdit = false;
  selectedFile = null;

  @Input() patientProfile: Patient;

  constructor(private patientService: PatientService, private formBuilder: FormBuilder) { }
  profileForm = this.formBuilder.group({

    /* Name */
    firstName: ['', Validators.required],
    preferredName: [''],
    middleName: [''],
    lastName: [''],

    /* info */
    birthDate: [''],
    birthCity: [''],
    birthState: [''],
    gender: [''],
    mobileContactNumber: [''],
    maritalStatus: [''],

    race: [''],
    ethnicity: [''],
    religiousPreference: [''],
    accompanyAssistance: [''],
    preferredLanguage: [''],
    secondaryLanguage: [''],
    interpreterNeeded: [''],
  });


  ngOnInit() {
  }

  toggleEdit() {
    this.isEdit = !this.isEdit;
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0];

    const payload = new FormData();
    payload.append('PatientId', this.patientProfile.id.toString());
    payload.append('ImageSource', this.selectedFile);

    this.patientService.uploadPatientProfilePicture(payload).subscribe(
      (res) => {
        if (res['isSuccess']) {
          this.patientService.getCurrentPatientDetails().subscribe(
            (data: Patient) => {
              this.patientProfile = data;
            },
            (error) => { console.error(error); });
        }
      },
      (error) => { console.error(error); }
    );
  }

  update() {
    this.isEdit = !this.isEdit;
    this.patientService.updatePatientDetails(this.patientProfile).subscribe(
      (_) => { },
      (error) => { console.error(error); }
    );
  }
}
